import { render } from "./QueryResult.vue?vue&type=template&id=093b7823&scoped=true"
import script from "./QueryResult.vue?vue&type=script&lang=js"
export * from "./QueryResult.vue?vue&type=script&lang=js"

import "./QueryResult.vue?vue&type=style&index=0&id=093b7823&scoped=true&lang=css"

import exportComponent from "C:\\Users\\schmidch\\IdeaProjects\\soilmap\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-093b7823"]])

export default __exports__